import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';
import {
  BlockReasonCreative,
  type BlockedCreative,
  type BlockedCreativeMutationPayload,
} from './model';

export const blockedCreativeFormSchema = z.object({
  creative: z
    .string()
    .trim()
    .min(1, { error: () => dashboardT('blockedList.creativeRequired') }),
  blockAll: z.boolean(),
  publisherIds: z.array(z.string()),
  reason: z.enum(BlockReasonCreative),
  comment: z.string(),
});

export type BlockedCreativeFormValue = z.infer<typeof blockedCreativeFormSchema>;

export function blockedCreativeInitialValue(
  creative: BlockedCreative | null,
): BlockedCreativeFormValue {
  return {
    creative: creative?.creative ?? '',
    blockAll: creative?.blockAll ?? false,
    publisherIds: creative?.publishers.map((publisher) => publisher.id) ?? [],
    reason: creative?.reason ?? BlockReasonCreative.None,
    comment: creative?.comment ?? '',
  };
}

export function serializeBlockedCreativeForm(
  value: BlockedCreativeFormValue,
  existing: BlockedCreative | null,
): BlockedCreativeMutationPayload {
  return {
    creative: value.creative.trim(),
    reason: value.reason,
    comment: value.comment.trim(),
    blockAll: value.blockAll,
    active: existing?.active ?? true,
    publisherIds: value.blockAll ? [] : value.publisherIds,
    domainIds: existing?.domains.map((domain) => domain.id) ?? [],
  };
}
